import {Parameter} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil, isNotNil, reject} from 'ramda';

import {BusinessCaseResponseBody} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {getNaturalPersonFullName} from '@dms/shared';

import {buildArray, isNotNilOrEmpty, Nullish, parseDate} from 'shared/web';

export function useGetParameters(
  businessCase: BusinessCaseResponseBody | undefined,
  note: string | Nullish,
  hasComments: boolean,
  onIconClick: () => void
) {
  const formatDateTime = useDateTimeFormatter();

  const getCreatedAt = isNotNil(businessCase?.createdAt)
    ? `${i18n.t('general.labels.dateCreated')}: ${formatDateTime(
        'dateTimeShort',
        parseDate(businessCase?.createdAt)
      )}`
    : null;

  const getClosedAt = isNotNil(businessCase?.closedAt)
    ? `${i18n.t('general.labels.dateClosed')}: ${formatDateTime(
        'dateTimeShort',
        parseDate(businessCase?.closedAt)
      )}`
    : null;

  const getCreatedBy = `${i18n.t('general.labels.createdBy')}: ${getNaturalPersonFullName(businessCase?.createdBy)}`;

  const getClosedBy = isNotNil(businessCase?.closedBy?.firstName)
    ? `${i18n.t('general.labels.closedBy')}: ${getNaturalPersonFullName(businessCase?.closedBy)}`
    : null;

  const parameters: Parameter[] = reject(isNil, [
    businessCase?.code,
    getCreatedBy,
    getCreatedAt,
    getClosedBy,
    getClosedAt,
  ]);

  return [
    buildArray<Parameter>()
      .when(isNotNilOrEmpty(note), {
        icon: 'action/description',
        title: null,
        variant: 'secondary',
        tooltip: note,
        onClick: onIconClick,
      })
      .when(hasComments, {
        icon: 'communication/comment',
        title: null,
        variant: 'secondary',
        hideSeparator: true,
        onClick: onIconClick,
      })
      .add(...parameters),
  ];
}
